import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import CrewToolbar from './crew-toolbar';
import WeeklDays from './weekdays';
import WeekView from './WeekView';
import moment from 'moment-timezone';
import HttpService from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import ButtonComponent from '../../../components/form/ButtonComponent';
import SimpleDialogComponent from '../../../components/SimpleDialogComponent';
import { useAlert } from '../../../components/alertContext';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import DatePickerCalendar from '../../../components/DatePickerCalendar';
import { handleErrorMessage } from '../../../utils/storageUtil';
interface CalendarViewProps {
  crewList: any[];

  token: string;
}
interface DayType {
  label: string;
  date: string;
  active: boolean;
  year: string;
}
const CalendarView: React.FC<CalendarViewProps> = ({ crewList, token }) => {
  const TIMEZONE = 'Australia/Sydney';
  const currentDate = moment.tz(TIMEZONE);

  const { alert, setAlert } = useAlert();
  const [weekDaysList, setwWeekDaysList] = useState<DayType[]>([]);
  const [shiftList, setShiftList] = useState<any[]>([]);
  const [weekOffset, setWeekOffset] = useState(0);
  const [inProgress, setInProgress] = useState(false);
  const [currentYear, setCurrentYear] = useState('');
  const [currentType, setCurrentType] = useState<any>('');
  const [currentShiftId, setCurrentShiftId] = useState<any>();
  const [currentShiftDate, setCurrentShiftDate] = useState<any>();
  const [week, setWeek] = useState<number>(7);
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
  const [dateDialogOpen, setDateDialogOpen] = useState<boolean>(false);
  const [noteList, setNoteList] = useState<any[]>([]);
  const [startDateDuplicateShift, setStartDateDuplicateShift] = useState<any>(
    moment.tz(TIMEZONE).add(week, 'days')
  );
  const generateWeekFromOffset = (offset: number) => {
    const startDate = moment.tz(TIMEZONE).add(offset * week, 'days');
    const days: DayType[] = [];

    for (let i = 0; i < week; i++) {
      const day = moment(startDate).add(i, 'days');
      days.push({
        label: day.format('ddd DD'),
        date: day.format('YYYY-MM-DD'),
        active: day.format('YYYY-MM-DD') === currentDate.format('YYYY-MM-DD'),
        year: day.format('Y DD'),
      });
    }
    setCurrentYear(moment(startDate).format('MMMM YYYY'));
    setwWeekDaysList(days);
    return days;
  };
  useEffect(() => {
    const days = generateWeekFromOffset(weekOffset);
    fetchCalendarShift(days[0].date, days[days.length - 1].date);
    dailyinfoList(days[0].date, days[days.length - 1].date);
  }, [weekOffset, week]);

  const fetchCalendarShift = async (startDate: any, endDate: any) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.shiftURL}/calendar`,
        { headers: { Authorization: `Bearer ${token}` } },
        { start: startDate, end: endDate }
      );
      console.log(response);
      if (response.data) {
        setShiftList(response.data.crews);
      } else {
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
    }
  };
  const dailyinfoList = async (startDate: any, endDate: any) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.dailyinfoURL}/range`,
        { headers: { Authorization: `Bearer ${token}` } },
        { start: startDate, end: endDate }
      );
      console.log(response);
      if (response.data) {
        setNoteList(response.data);
      } else {
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
    }
  };
  const handleMoreMenu = async (type: any, id: any, date: any) => {
    console.log(date);
    setCurrentShiftId(id);
    setCurrentType(type);
    setCurrentShiftDate(date);
    if (type === 'delete') {
      setConfirmDailogOpen(true);
    }
    if (type === 'duplicate') {
      setDateDialogOpen(true);
    }
  };
  const handleSuccess = (response: any) => {
    const days = generateWeekFromOffset(weekOffset);
    fetchCalendarShift(days[0].date, days[days.length - 1].date);
    dailyinfoList(days[0].date, days[days.length - 1].date);
    setAlert({
      type: 'success',
      message: response.data,
      open: true,
    });
  };
  const handleDelete = async () => {
    try {
      setInProgress(true);
      const response = await HttpService.patch(
        `${Constants.apiURL + Constants.shiftURL}/${currentShiftId}/delete`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setInProgress(false);
      console.log(response);
      if (response.data) {
        clearShift();
        handleSuccess(response);
      } else {
        setInProgress(false);
      }
    } catch (error: any) {
      setInProgress(false);

      console.error(`Error fetching data:`, error);
    }
  };
  const clearShift = () => {
    setConfirmDailogOpen(false);
    setCurrentShiftId(null);
    setCurrentType('');
  };
  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>Are you sure you want to delete this shift?</h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label={inProgress ? 'processing...' : 'Yes'}
            onClick={handleDelete}
          />
          <ButtonComponent
            errors={[]}
            keyName="cancelbuttonconfirm"
            label="Cancel"
            onClick={() => {
              clearShift();
            }}
          />
        </Box>
      </Box>
    );
  };
  const handleDuplicate = async () => {
    try {
      const dupDate = startDateDuplicateShift.format('YYYY-MM-DD');
      /*if (currentShiftDate === dupDate) {
        setAlert({
          open: true,
          message: 'Please try different date',
          type: 'error',
        });
        return false;
      }*/
      setInProgress(true);
      const response = await HttpService.post(
        `${Constants.apiURL + Constants.shiftURL}/${currentShiftId}/duplicate`,
        { dates: [dupDate] },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setInProgress(false);
      if (response.data) {
        setDateDialogOpen(false);
        clearShift();
        handleSuccess(response);
      } else {
      }
    } catch (error: any) {
      setInProgress(false);
      setAlert({
        open: true,
        message: handleErrorMessage(error),
        type: 'error',
      });
      console.error(`Error fetching data:`, error);
    }
  };
  const dateDialog = () => {
    return (
      <Box>
        <Box sx={{}}>
          <DatePickerCalendar
            defaultValue={startDateDuplicateShift}
            onChange={(val) => {
              setStartDateDuplicateShift(val);
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okDuplicate"
            label={inProgress ? 'processing...' : 'Ok'}
            onClick={handleDuplicate}
          />
          <ButtonComponent
            errors={[]}
            keyName="cancelButtonDuplicate"
            label="Cancel"
            onClick={() => {
              setDateDialogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  return (
    <Paper
      sx={{
        width: '100%',
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
      }}
      className="mt-4"
    >
      <CrewToolbar
        offset={weekOffset}
        onEventClick={(offsetIndex) => {
          setWeekOffset(offsetIndex);
        }}
        currentYear={currentYear}
        week={week}
        onWeekChange={(weekNum: number) => {
          setWeek(weekNum);
        }}
      ></CrewToolbar>
      <Box sx={{ overflowX: 'scroll' }}>
        {/* <WeeklDays
          token={token}
          weekDays={weekDaysList}
          noteList={noteList}
          refreshNotes={() => {
            const days = generateWeekFromOffset(weekOffset);
            dailyinfoList(days[0].date, days[days.length - 1].date);
          }}
        ></WeeklDays> */}
        <WeekView
          handleMoreMenu={handleMoreMenu}
          weekDays={weekDaysList}
          crewList={crewList}
          shiftList={shiftList}
          noteList={noteList}
          token={token}
          refreshNotes={() => {
            const days = generateWeekFromOffset(weekOffset);
            dailyinfoList(days[0].date, days[days.length - 1].date);
          }}
        ></WeekView>
      </Box>
      <SimpleDialogComponent
        title={'Shift Removal?'}
        dialogContent={dialogConfirmation()}
        open={confirmDailogOpen}
        handleClose={() => {
          clearShift();
        }}
      />
      <SimpleDialogComponent
        title={'Choose Date for Shift'}
        dialogContent={dateDialog()}
        open={dateDialogOpen}
        handleClose={() => {
          setDateDialogOpen(false);
        }}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={() => {
          setAlert({ open: false, message: '', type: 'success' });
        }}
        message={alert.message}
      />
    </Paper>
  );
};

export default CalendarView;
